export const handleSetColorTitleStatus = (
    type: "title" | "color",
    status: number
  ) => {
    if (type === "title") {
      switch (status) {
        case 0:
          return "Taslak";
        case 1:
          return "Onay Bekliyor";
        case 2:
          return "Yayında";
        case 3:
          return "Süresi Doldu";
        case 4:
          return "Kullanıcı Tarafından Yayından Kaldırıldı";
        case 6:
          return "Yönetici Tarafından Reddedildi";
        case 7:
          return "Yönetici Tarafından Yayından Kaldırıldı";
        case 8:
          return "Satıldı";
        default:
          return "Bilinmeyen Durum";
      }
    } else {
      switch (status) {
        case 0:
          return "blue";
        case 1:
          return "gold";
        case 2:
          return "green";
        case 3:
          return "error";
        case 4:
          return "error";
        case 6:
          return "error";
        case 7:
          return "error";
        case 8:
          return "green";
        default:
          return "defaultColor";
      }
    }
  };